import { render } from "./bpmodule.vue?vue&type=template&id=d0cf9590&scoped=true"
import script from "./bpmodule.vue?vue&type=script&lang=js"
export * from "./bpmodule.vue?vue&type=script&lang=js"

import "./bpmodule.vue?vue&type=style&index=0&id=d0cf9590&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cf9590"]])

export default __exports__